import { CONFIG } from "~/config";
import { createDashboardIcon, EDashboardIconType } from "./dashboardicon";
import { node } from "~/util/dom";

interface IDashboardItemOptions extends Partial<HTMLAnchorElement> {
	titleHTML: string;
	subtitleHTML: string;
	iconType: EDashboardIconType;
}

export function createDashboardItem({
	className = "",
	titleHTML = "",
	subtitleHTML = "",
	iconType,
	...rest
}: IDashboardItemOptions): HTMLAnchorElement | HTMLSpanElement {
	const link = CONFIG.isScreenshoter
		? node("span", {
			className: `ui-dashboard-item ${className}`,
			innerHTML: ``,
			...rest,
		})
		: node("a", {
			className: `ui-dashboard-item ${className}`,
			innerHTML: ``,
			...rest,
		});
	const icon = createDashboardIcon({
		type: iconType,
	});
	const text = node("div");

	link.append(icon, text);
	text.append(node("h2", { innerHTML: titleHTML }), node("p", { innerHTML: subtitleHTML }));

	return link;
}
